<template>
  <span class="icon">
    <template v-if="value">
      <i class="fas fa-check"/>
    </template>
    <template v-else>
      <i class="fas fa-times"/>
    </template>
  </span>
</template>

<script>
// const debug = require('debug')('OD::BaseTableBoolean')

export default {
  name: 'BaseTableBoolean',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>

</style>
